
export const notifications = ref<AppNotification[]>([]);

export function notify(notification: AppNotification|string) {
  if (typeof notification === 'string') {
    notification = {
      text: notification,
      type: 'success',
      timeout: 3000,
    };
  }

  notification.id ??= window.crypto.getRandomValues(new Uint32Array(1))[0]
  notification.timeout ??= 3000

  if(notifications.value.find(n => n.id === notification.id)) {
    const replacing = notifications.value.find(n => n.id === notification.id);
    console.log('replace', notification.id, replacing);

    disolveNotification(replacing as any);
    notifications.value.push(notification);
  }else{
    notifications.value.push(notification);
  }

  return notification;
}

export function disolveNotification(notification: AppNotification) {
  const index = notifications.value.indexOf(notification);
  if (index > -1) {
    notifications.value.splice(index, 1);
  }
}

export function confirmingAction(text?: string|undefined, button?: string|undefined) {
  if (!text) {
    text = useT('notification.confirmaction.text');
  }

  if (!button) {
    button = useT('notification.confirmaction.button');
  }

  return new Promise((resolve, reject) => {
    notify({
      text,
      button: button || 'Confirm',
      type: 'info',
      buttonaction: () => {
        resolve(true);
      }
    })

    setTimeout(() => {
      reject(new Error('Action cancelled'));
    }, 3000);
  })
}
